import { render, staticRenderFns } from "./TrainDeviationArrivalFields.vue?vue&type=template&id=6c3045bb"
import script from "./TrainDeviationArrivalFields.vue?vue&type=script&lang=js"
export * from "./TrainDeviationArrivalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports